import { createContext, useContext, useState, useCallback, FC, ReactNode } from 'react'
import { api } from '../services/apiClient'

interface User {
  id: number;
  firmId: number;
  email: string;
  fullName: string;
  firstName: string;
  lastName: string;
  role: string;
  isFirmAdministrator: boolean;
  firmName: string;
  firmNumber: string;
}

interface AuthContextData {
  user: User;
  validateToken(token: string): Promise<User | undefined>;
  validateCookies(): Promise<User | undefined>
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData)

export const AuthProvider: FC<{ children: ReactNode }> = ({children}) => {
  const [user, setUser] = useState<User>({} as User)

  const validateToken = useCallback(async (token: string) => {
    try {
      const response = await api.patch('/MagicLinks/validate', { token })

      setUser(response.data)
      
      return response.data
    } catch (error) {
      return undefined
    }
  }, [])
  
  const validateCookies = useCallback(async () => {
    try {
      const response = await api.get('/MagicLinks/testcookie')

      setUser(response.data)
      
      return response.data
    } catch (error) {
      return undefined
    }
  }, [])

  return (
    <AuthContext.Provider
      value={{ user, validateToken, validateCookies }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext)

  if(!context) throw new Error('useAuth must be used within an AuthProvider!')

  return context
}